import {
  IGetDataIndicatorOfStationPayload,
  IResponseGetDataIndicatorOfStation,
} from 'src/types/monitoring_data';
import { IPayloadGetAdvanceData, IResponseGetAdvanceData } from './../../types/statistic';
import { createClient } from './axios_client';
const client = createClient('http://localhost:9004/api/v1');

export const monitoringDataApi = {
  getData: (payload: IPayloadGetAdvanceData) => {
    const newPayload = {
      ...payload,
      dataType: payload.dataType,
      startTime: payload.startTime,
      endTime: payload.endTime,
      limit: payload.limit,
      page: payload.page,
    };
    return client.post<IResponseGetAdvanceData>(
      `/monitoring_data/${payload.stationId}`,
      newPayload,
    );
  },

  exportData: (payload: Omit<IPayloadGetAdvanceData, 'page' | 'limit'>) => {
    const newPayload = {
      ...payload,
      dataType: payload.dataType,
      startTime: payload.startTime,
      endTime: payload.endTime,
    };
    return client.post<any>(`/monitoring_data/${payload.stationId}/export`, newPayload, {
      responseType: 'blob',
      timeout: 10000000,
    });
  },

  getDataIndicatorOfStation: ({
    payload,
    params,
  }: {
    payload: IGetDataIndicatorOfStationPayload;
    params: {
      stationId: string;
      indicatorSymbol: string;
    };
  }) => {
    return client.post<IResponseGetDataIndicatorOfStation[]>(
      `/monitoring_data/${params.stationId}/indicator/${params.indicatorSymbol}`,
      payload,
    );
  },

  getLatestDataOfPoint: (point: { lat: number; lng: number }) => {
    return client.post(`/monitoring_data/point`, point);
  },
};
